import { render, staticRenderFns } from "./o-layered-container.vue?vue&type=template&id=337332e0&"
import script from "./o-layered-container.vue?vue&type=script&lang=js&"
export * from "./o-layered-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports